// @flow

import { createFlags } from "flag";
import { getFeatureFlags } from "../api/actions";

export const LEASING_FLOW = "leasing_flow";
export const OKP_INQUIRY_FLOW = "okp_api_and_inquiry";
export const OKP_HIDE_PASSWORD_BASED_LOGIN = "okp_hide_password_based_login";
export const WELCOME_CALL_COLUMN = "welcome_call_column";
export const IS_CONSULTANT_COLUMN = "is_consultant_column";
export const PRIVACY_POLICY_CHECKBOX = "privacy_policy_checkbox";
export const INQUIRIES_LIST_SEARCH = "inquiries_list_search";
export const PROCEED_ON_COLUMN = "proceed_on_column";
export const INQUIRY_FORM_LINK = "inquiry_form_link";
export const EQUITY_FINANCING = "equity_financing";
export const HIDE_EXCLUDED_AND_USED_BANKS = "hide_excluded_and_used_banks";
export const PASSWORD_RESET = "password_reset";
export const ARCHIVING_REASON = "archiving_reason";
export const CONSULTANT_INQUIRIES_VIEW = "consultant_inquiries_view";
export const CREATE_FILE_UPLOAD_REQUESTS_IN_BATCH = "create_file_upload_requests_in_batch";

export type FeatureFlagsType = {
  [LEASING_FLOW]: boolean,
  [OKP_INQUIRY_FLOW]: boolean,
  [OKP_HIDE_PASSWORD_BASED_LOGIN]: boolean,
  [WELCOME_CALL_COLUMN]: boolean,
  [IS_CONSULTANT_COLUMN]: boolean,
  [PRIVACY_POLICY_CHECKBOX]: boolean,
  [INQUIRIES_LIST_SEARCH]: boolean,
  [PROCEED_ON_COLUMN]: boolean,
  [INQUIRY_FORM_LINK]: boolean,
  [EQUITY_FINANCING]: boolean,
  [HIDE_EXCLUDED_AND_USED_BANKS]: boolean,
  [PASSWORD_RESET]: boolean,
  [ARCHIVING_REASON]: boolean,
  [CONSULTANT_INQUIRIES_VIEW]: boolean,
  [CREATE_FILE_UPLOAD_REQUESTS_IN_BATCH]: boolean
};

const REVERSE_FLAGS = [OKP_HIDE_PASSWORD_BASED_LOGIN];

export const flagsStatus = async (featureFlags: Array) => {
  const payload = await getFeatureFlags(featureFlags);

  return payload.data.data.reduce((acc, input) => {
    acc[input.id] = input.attributes.state === "on";

    if (REVERSE_FLAGS.includes(input.id)) {
      acc[input.id] = !acc[input.id];
    }

    return acc;
  }, {});
};

const { FlagsProvider, Flag, useFlag, useFlags } = createFlags<FeatureFlagsType>();
export { FlagsProvider, Flag, useFlag, useFlags };
